import { useState, useEffect, useRef } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import CustomPaper from "../CustomPaper";
import SearchField from "../SearchField";
import { IconButtonPaper } from "../IconButtonPaper";
import IconComponent from "../../components/ui/IconComponent";
import { BotFilter } from "./types";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  onChange: (value: any) => void;
  options: BotFilter[];
  searchValue: string;
  onChangeSearch: (value: string) => void;
}

const BotFilters = ({ value, onChange, options, onChangeSearch, searchValue }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation("botsList");

  const [showFilters, setShowFilters] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState<number>(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [options]);

  return (
    <CustomPaper sx={{ padding: "8px !important" }}>
      <Stack direction={"column"}>
        <Stack direction={"row"} spacing={1}>
          <SearchField value={searchValue} onChange={onChangeSearch} />
          <IconButtonPaper onClick={() => setShowFilters((prev) => !prev)} hasBorder={showFilters}>
            <IconComponent hasFill={true} hasStroke iconName={"caret-sort"} size={18} />
          </IconButtonPaper>
        </Stack>
        <Box
          style={{
            height: showFilters ? `${contentHeight}px` : "0px",
            overflow: "hidden",
            transition: "all  350ms cubic-bezier(0.4, 0, 0.2, 1)",
            opacity: showFilters ? 1 : 0,
            marginTop: showFilters ? "24px" : 0,
          }}
        >
          <Box ref={contentRef}>
            <FormControl sx={{ width: "100%" }}>
              <FormLabel
                sx={{
                  color: theme.palette.text.secondary + "!important",
                  paddingBottom: 2,
                }}
                id="adron-bots-controlled-radio-buttons-group"
              >
                {t("sortType")}
              </FormLabel>
              <RadioGroup
                aria-labelledby="adron-bots-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={onChange}
              >
                {options.map((option: BotFilter, index: number) => (
                  <Stack
                    key={index}
                    direction="row"
                    alignItems={"center"}
                    sx={{ width: "100%" }}
                    justifyContent={"space-between"}
                  >
                    <FormControlLabel
                      sx={{ height: "29px" }}
                      value={`${option.value}`}
                      control={
                        <Radio
                          color={"default"}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 24,
                            },
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ fontSize: "14px !important" }}>
                          {option.label}{" "}
                          <span style={{ opacity: 0.5, fontWeight: 400 }}>{option.subLabel}</span>
                        </Typography>
                      }
                    />
                    <IconComponent iconName={option.sortIcon} size={18} hasStroke hasFill />
                  </Stack>
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
      </Stack>
    </CustomPaper>
  );
};

export default BotFilters;
